<template>
  <div class="container">
    <van-search
      v-model="value"
      placeholder="请输入搜索关键词"
      show-action
      shape="round"
      @search="handleInputVlaue"
      @input="handleInputVlaue"
      @focus="handleFoucsClick"
      @clear="handleFoucsClick"
    >
      <div slot="action" class="right-icon" @click="handleShowPolice">筛选</div>
    </van-search>
    <div v-if="isShowHistory">
      <div
        class="search-list"
        v-for="(item,index) in searchList"
        :key="index"
        @click="handleClickGoPage(item.siteId)"
      >{{item.siteName}}</div>
    </div>
    <!-- 搜索历史记录 -->
    <div v-else>
      <div class="search-list" v-for="(item,index) in historyList" :key="index" @click="handleHistoryClick(item.content)">
        {{item.content}}
        <span style="float:right;display:inline-block;width:10%;text-align:center" @click.stop="handleDelClikc(item.id)">X</span>
      </div>
    </div>
    <van-popup v-model="show" position="top" :style="{ height: '80%' }">
      <van-tree-select height="70%" :items="items" :main-active-index.sync="activeIndex"  @click-nav="onNavClick">
        <template slot="content">
           <ul class="right-content">
            <!-- <li>不限</li> -->
            <li  v-for="(item,index) in policeList" :key="index" :class="{active:policeCode==item.policeCode}"  @click="onItemClick(item.policeName,item.policeCode)"> {{item.policeName}} </li>
          </ul>
        </template>
      </van-tree-select>
        <div class="btn" @click="onPoliceClick">完成</div>
    </van-popup>
  </div>
</template>

<script>
import { Search } from "vant";
import { Popup } from "vant";
import { TreeSelect } from "vant";
import { branchInfo,PoliceList } from "@/api/public";
import {
  SearchCustomer,
  HistorySearchCustomer,
  HistorySearchListCustomer,
  DelHistorySearchListCustomer
} from "@/api/customer";
import { truncateSync } from "fs";
export default {
  components: {
    vanSearch: Search,
    vanPopup: Popup,
    vanTreeSelect: TreeSelect
  },
  data() {
    return {
      value: "",
      searchList: [],
      historyList: [],
      isShowHistory: true,
      show: false,
      activeIndex: 0,
      items: [],
      policeList:[],
      policeCode:'',
      substationCode:''
    };
  },
  mounted() {
    this.requestSearchCustomer(this.substationCode,this.policeCode);
    this.requestBranchInfo()
  },
  methods: {
    // 搜索网吧列表
    requestSearchCustomer(substationCode,policeCode) {
      SearchCustomer({substationCode:substationCode,policeCode:policeCode}).then(res => {
        console.log(res);
        this.searchList = res.data;
      });
    },
    // 根据场所名搜索
    requestHistorySearchCustomer() {
      HistorySearchCustomer({ siteName: this.value }).then(res => {
        this.searchList = res.data;
      });
    },
    // 历史记录
    requestHistorySearchListCustomer() {
      HistorySearchListCustomer().then(res => {
        console.log(res);
        this.historyList = res.data;
        this.isShowHistory = false;
      });
    },
    //  删除历史记录
    requestDelHistorySearchCustomer(id) {
      console.log(id);
      DelHistorySearchListCustomer({ id: id }).then(res => {
        if (res.code == 200) {
          this.requestHistorySearchListCustomer();
     
        }
      });
    },
    // 点击筛选请求分局
    requestBranchInfo() {
      branchInfo().then(res => {
        let branchList = res.data;
           this.items.push({
             activeId:'',
             text:'全城'
           })
        branchList.forEach(element => {
           this.items.push({
              activeId:element.substationCode,
              text:element.substationName
           })
        });
        // 默认加载分区的第一个index 
        let substationCode = this.items[0].activeId
        // 默认加载派出所列表
        this.requestPoliceList(substationCode);
      });
    },
    // 点击请求派出所
    requestPoliceList(substationCode) {
        PoliceList({substationCode:substationCode}).then(res=>{
          console.log(res)
          if(res.code==200) {
              res.data.unshift({
                 policeCode:'',
                 policeName:'不限'
              })
              this.policeList = res.data
          }
        })  
    },
    handleHistoryClick(content) {
        console.log(content)
        this.value = content
        this.requestHistorySearchCustomer()
        this.isShowHistory = true

    },
    // 点击分局
      onNavClick(index) {
       console.log(index)    
        // 获取分区的ID,通过ID去找到当前的派出所
        let substationCode = this.items[index].activeId
        console.log(substationCode)
        this.substationCode= substationCode
        this.requestPoliceList(substationCode)
    },
    // 点击完成
      onPoliceClick() {
       this.show = false
    },
    // 点击派出所
     onItemClick(policeName,policeCode) {
        console.log(policeName,policeCode)
        let substationCode = this.substationCode
        this.requestSearchCustomer(substationCode,policeCode)
        this.policeCode = policeCode
    },
    handleDelClikc(id) {
      //  console.log(id)
      this.requestDelHistorySearchCustomer(id);
    },

    // 搜索显示值
    handleInputVlaue() {
      this.requestHistorySearchCustomer();
      this.isShowHistory = true;
    },
    // 获取焦点事件
    handleFoucsClick() {
      console.log("11");
      this.requestHistorySearchListCustomer();
    },
    // 点击筛选显示
    handleShowPolice() {
      this.show = true;
    },
    // 点击跳转页面
    handleClickGoPage(id) {
      console.log(id)
      this.$router.push({
        path: "/customerinfo",
        query: {
          internetBarId: id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow: hidden;
  .active {
    color: #008CFF !important;
  }
  .right-icon {
    width: 57px;
    height: 35px;
    border-radius: 10px;
    color: #ffffff;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
  }
  .search-list {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    background-color: #ffffff;
    text-align: left;
    font-size: 15px;
    border-bottom: 1px solid #f2f2f2;
  }
    // 选择派出所
  .right-content {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    li {
      font-size: 15px;
      color: #000000;
      text-align: left;
      height: 44px;
      line-height: 44px;
    }
  }
  .btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 55px auto;
    text-align: center;
  }
}
</style>
